module.exports = __webpack_public_path__ + "static/media/veryvell_strawberry.61262569.png";